import { render, staticRenderFns } from "./StatsDisplayTable.vue?vue&type=template&id=0fb1517b&scoped=true&"
import script from "./StatsDisplayTable.vue?vue&type=script&lang=js&"
export * from "./StatsDisplayTable.vue?vue&type=script&lang=js&"
import style0 from "./StatsDisplayTable.vue?vue&type=style&index=0&id=0fb1517b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1517b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb1517b')) {
      api.createRecord('0fb1517b', component.options)
    } else {
      api.reload('0fb1517b', component.options)
    }
    module.hot.accept("./StatsDisplayTable.vue?vue&type=template&id=0fb1517b&scoped=true&", function () {
      api.rerender('0fb1517b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/StatsDisplayTable.vue"
export default component.exports